var document = require(18).document;
module.exports = document && document.documentElement;
